import React, { useCallback, useState } from 'react';

import { StyleSheet, View } from 'react-native';

import ActionButton, { ActionButtonSizes } from 'components/action-button';
import { ConfettiAnimation } from 'components/ui/confetti-animation';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';

const MAX_LOOPS = 3;

interface PromotionActivationButtonProps {
  onPress: () => void;
  isLoading: boolean;
}

export const PromotionActivationButton: React.FC<PromotionActivationButtonProps> = ({
  onPress,
  isLoading,
}) => {
  const label = isLoading ? t('activating', 'Activating') : t('activate');
  const [loopCount, setLoopCount] = useState(0);

  const showConfetti = isLoading && loopCount < MAX_LOOPS;

  const handleAnimationLoop = useCallback(() => {
    setLoopCount(prev => prev + 1);
  }, []);

  const handlePress = useCallback(() => {
    setLoopCount(0);
    onPress();
  }, [onPress]);

  return (
    <View style={styles.wrapper}>
      <ActionButton
        size={ActionButtonSizes.SMALL}
        accessibilityLabel={label}
        onPress={handlePress}
        disabled={isLoading}
        backgroundColor={primitive.$meltyYellow}
        _text={{ color: primitive.$bbqBrown }}
        height={spacing.$1_5}
        _hover={{ backgroundColor: primitive.$meltyYellowDark45 }}
        _pressed={{ backgroundColor: primitive.$meltyYellowDark40 }}
        _disabled={{ backgroundColor: primitive.$meltyYellow, borderWidth: 0 }}
        color={primitive.$bbqBrown}
        style={styles.button}
      >
        {label}
      </ActionButton>
      <ConfettiAnimation isActive={showConfetti} loop onAnimationLoop={handleAnimationLoop} />
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    zIndex: 1,
  },
  button: {
    paddingTop: 0,
    paddingBottom: 0,
  },
});
